import { TermDto } from '@act/shared/data-transfer-objects';
import { IconLibrary } from '@act/storybook';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import useTermConsentsDialog from 'react-components/dialog-forms/hooks/use-term-consents-dialog';

interface ConsentsListProps {
  terms: TermDto[];
}

const ConsentsList = ({ terms }: ConsentsListProps) => {
  const openTermDialog = useTermConsentsDialog();

  return (
    <Box sx={{ margin: '0 auto 8px' }}>
      <List disablePadding>
        {terms.map(term => {
          let icon = <CircleOutlinedIcon />;
          if (term.consented === true) {
            icon = <IconLibrary iconName="CheckCircle" color="success" />;
          } else if (term.consented === false) {
            icon = <IconLibrary iconName="XCircle" color="error" />;
          }
          return (
            <ListItem key={term.key} disablePadding>
              <ListItemButton onClick={() => openTermDialog({ term })}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>
                  <Typography variant="titleSmall">{term.name}</Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default ConsentsList;
